export default {
	nodes: [
		{
			id: '8a26c963-8b3e-4289-8f1a-a546f40e8950',
			type: 'FlowchartColumn',
			data: {
				title: 'Initiating',
				name: 'column-1'
			},
			position: {x: 0, y: 0}
		},
		{
			id: '7f44404f-2ba7-414a-b946-8cf36d4c2077',
			type: 'FlowchartColumn',
			data: {
				title: 'Processing',
				name: 'column-2'
			},
			position: {x: 780, y: 0}
		},
		{
			id: '78f4d4da-a2f8-4674-834e-0528d5463552',
			type: 'FlowchartColumn',
			data: {
				title: 'Recording',
				name: 'column-3'
			},
			position: {x: 1576, y: 0}
		},
		{
			id: '8df91070-1224-4357-b440-a70724d5a588',
			type: 'FlowchartColumn',
			data: {
				title: 'Reporting',
				name: 'column-4'
			},
			position: {x: 2363, y: 0}
		},
		{
			id: '844fffbc-afd2-482a-8ec4-4ae8eca2df9d',
			type: 'FlowchartStep',
			data: {
				title: 'Title',
				description: 'Description',
				name: 'column-1-card',
				attachments: [
					{
						type: '',
						item: {
							link: 'link',
							name: 'name'
						}
					}
				]
			},
			position: {
				x: 100,
				y: 100
			},
			parentId: '8a26c963-8b3e-4289-8f1a-a546f40e8950'
		},
		{
			id: '4648f470-6f14-48e4-a5f4-f943088ac65b',
			type: 'FlowchartStep',
			data: {
				title: 'Title 2',
				description: 'Description',
				name: 'column-2-card'
			},
			position: {
				x: 100,
				y: 100
			},
			parentId: '7f44404f-2ba7-414a-b946-8cf36d4c2077'
		},
		{
			id: '69521aac-a4f8-4f9a-a596-20ed7c459aac',
			type: 'FlowchartStep',
			data: {
				title: 'Title 3',
				name: 'column-3-card',
				description: 'Description'
			},
			position: {
				x: 100,
				y: 100
			},
			parentId: '78f4d4da-a2f8-4674-834e-0528d5463552'
		},
		{
			id: '34af3f6a-54a1-4da3-8134-db2a5fb6f27d',
			type: 'FlowchartStep',
			data: {
				title: 'New or renewed customer contracts',
				name: 'column-4-card',
				description: 'the Programs Dept.'
			},
			position: {
				x: 100,
				y: 100
			},
			parentId: '8df91070-1224-4357-b440-a70724d5a588'
		},
		{
			id: '6d1ff6b1-24df-4419-aea5-4b1b4134be00',
			type: 'FlowchartStep',
			data: {
				title: 'Title 5',
				description: 'Description'
			},
			position: {
				x: 100,
				y: 300
			},
			parentId: '78f4d4da-a2f8-4674-834e-0528d5463552'
		}
	],
	edges: [
		{
			id: 'e1-2',
			source: '844fffbc-afd2-482a-8ec4-4ae8eca2df9d',
			sourceHandle: '4',
			target: '6d1ff6b1-24df-4419-aea5-4b1b4134be00',
			targetHandle: '3',
			type: 'custom-edge'
		}
	]
};
